import { Injectable } from '@angular/core';
import { loginInterface } from '../Model/login.Interface';
import { HttpClient } from '@angular/common/http';
import { MatDialog } from '@angular/material';
import {environment} from '../../environments/environment'

@Injectable({
  providedIn: 'root'
})
export class LoginService {
  private data: any = {};
  constructor(private http: HttpClient, private dialog: MatDialog){}

  logueo(url: string, params: any) {
    return this.http.post<loginInterface>(environment.apiUrlS + url, params);
  }
  logueoLc(url: string, params: any) {
    return this.http.post<loginInterface>(environment.apiUrl + url, params);
  }

  cerrarSesion() {
    // Los MatDialog (ej. el modal de revisar/subir documentos) viven en el
    // overlay global de CDK, fuera del router-outlet: si quedan abiertos al
    // cerrar sesión, el router destruye la página pero no el diálogo, y el
    // siguiente usuario que inicie sesión en la misma pestaña lo ve superpuesto.
    this.dialog.closeAll();
    localStorage.clear();
    sessionStorage.clear();
  }

  // setData(key: string, value: any) {
  //   this.data[key] = value;
  // }

  getData(key: string) {
    // const value = this.data[key];
    // return value;
    return sessionStorage.getItem(key);
  }

}
